import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

// eslint-disable-next-line import/prefer-default-export
export const useDatasetMappedIcon = (mapValue: number | undefined, mapperId: number) => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);

  if (isLoading) return null;
  if (mapValue === undefined) return "N/A";
  if (!data || !data.mappingIcons) return mapValue;
  return `pi ${data.mappingIcons[mapValue]}`;
};

